import React, { Component } from 'react';

import reqwest from 'reqwest';

import {
    Form, Upload, Button, Icon,
} from 'antd';

const FormItem = Form.Item;

class UploadField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            uploading: false,
        }
        
    }

    render() {
        const { label, onRemove,  beforeUpload, fileList} = this.props;
        const props = {
            onRemove,
            beforeUpload,
            fileList,
        };

        return (
            <FormItem label={label}>
                <Upload {...props}>
                    <Button>
                    <Icon type="upload" /> Select File
                    </Button>
                </Upload>
            </FormItem>     
        );
    }
}

export default UploadField;